import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient, ConvertParamsToFormData } from "~/utils";

import {
  ApiMembersDirectMessageRoomsDirectMessagesMutateType,
  PreviewWithFileType,
  RawDraftContentState,
} from "~/domains";

type RequestDataType = {
  directMessageRoomId: string;
  id: string;
  body: {
    content: RawDraftContentState;
    attachFiles: PreviewWithFileType[];
  };
};

const request = ({ directMessageRoomId, id, body }: RequestDataType) => {
  const formData = ConvertParamsToFormData({ directMessage: body });
  return new ApiClient()
    .put<ApiMembersDirectMessageRoomsDirectMessagesMutateType>(
      `/api/members/direct_message_rooms/${directMessageRoomId}/direct_messages/${id}`,
      formData,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersDirectMessageRoomsDirectMessagesUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiMembersDirectMessageRoomsDirectMessagesMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
